var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderBox',{attrs:{"index":"4"}}),_vm._v(" "),_c('div',{staticClass:"split"}),_vm._v(" "),_c('section',[_c('article',{staticClass:"fl"},[_c('ArticleList',{attrs:{"title":"曲径通幽"}})],1),_vm._v(" "),_c('AsideBox')],1),_vm._v(" "),_c('FooterBox')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67972417","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TechnologyView.vue
// module id = null
// module chunks = 